export default __webpack_public_path__ + "static/media/logout.c12ca098.svg";